import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { TransactionManagement } from "./Transactions";
import { Switch } from "react-router-dom";
import { Permissions } from "../../../util/Permissions";

const TransactionManagementPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/transactions" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/transactions/:userGroup" permission={Permissions.TRANSACTIONS} component={TransactionManagement} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default TransactionManagementPages;
